import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

export const CheckBoxGroupItem = ({ style, selected, i, onClick, steps }) => {
  const doNothing = () => null

  const onClickFunction = (e) => {
    if (e?.detail !== 1) doNothing()
    else onClick(e)
  }

  return (
    <div
      className={`community-step-card ${selected ? 'is-selected' : ''}`}
      style={style}
      onClick={onClickFunction}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClickFunction(e)}
    >
      <div className="community-step-card__label">
        {t.step} {i}
      </div>
      {steps.slice(0, parseInt(i) + 1).map((step, index) => (
        <div key={step} className="community-step-card__step">
          <span className={`community-step-card__dot ${index <= parseInt(i) ? 'is-active' : ''}`} />
          {step}
        </div>
      ))}
      {selected && (
        <div
          style={{
            marginTop: 10,
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--primary)',
            textTransform: 'uppercase',
            letterSpacing: '0.04em'
          }}
        >
          {t.selezionato}
        </div>
      )}
    </div>
  )
}
